import { useThemeStore } from '@store/themeStore';
import { useBrandStore } from '../store/brandStore';
import { lightColors, darkColors, ThemeColors } from '../theme/colors';
import { brandedPalette } from '../theme/brand';
import { SPACING } from '../theme/spacing';
import { TYPOGRAPHY, FONT_SIZES } from '../theme/typography';
import { BORDER_RADIUS } from '../theme/borderRadius';
import { ELEVATION } from '../theme/elevation';

interface ThemeHookResult {
  colors: ThemeColors;
  isDark: boolean;
  spacing: typeof SPACING;
  typography: typeof TYPOGRAPHY;
  fontSizes: typeof FONT_SIZES;
  borderRadius: typeof BORDER_RADIUS;
  elevation: typeof ELEVATION;
}

export function useTheme(): ThemeHookResult {
  const activeTheme = useThemeStore((state) => state.activeTheme);
  const brand = useBrandStore((state) => state.activeBrand);
  const base = activeTheme === 'dark' ? darkColors : lightColors;

  return {
    colors: brand ? brandedPalette(base, activeTheme, brand) : base,
    isDark: activeTheme === 'dark',
    spacing: SPACING,
    typography: TYPOGRAPHY,
    fontSizes: FONT_SIZES,
    borderRadius: BORDER_RADIUS,
    elevation: ELEVATION,
  };
}
